import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiFacebook, FiInstagram, FiLinkedin, FiYoutube } from "react-icons/fi";
import SteffiDevice from "../components/SteffiDevice";
import Reveal from "../components/Reveal";
import { useWaitlist } from "../components/Waitlist";
import { useSteffiCopy } from "../content";

const SOCIAL_ICONS = {
  instagram: FiInstagram,
  facebook: FiFacebook,
  linkedin: FiLinkedin,
  youtube: FiYoutube,
};

export default function Finale() {
  const { FINALE, FOOTER } = useSteffiCopy();
  const openWaitlist = useWaitlist();

  return (
    <section
      id="warteliste"
      className="relative overflow-hidden pt-28 lg:pt-40"
      style={{
        background:
          "var(--bg)",
      }}
    >
      <div className="mx-auto w-full max-w-[1440px] px-6 lg:px-10">
        {/* She looks straight back at the visitor. No wrapper may transform
            here, or the render stops blending with the background. */}
        <div className="relative mx-auto w-[clamp(15rem,46vw,23rem)]">
          <div
            aria-hidden
            className="glow-blob pointer-events-none absolute left-1/2 top-[42%] h-[130%] w-[130%] -translate-x-1/2 -translate-y-1/2"
            style={{
              background:
                "radial-gradient(circle, rgba(215,180,138,.5) 0%, rgba(234,220,207,.3) 40%, rgba(252,247,243,0) 70%)",
            }}
          />
          <SteffiDevice variant="front" alt={FINALE.alt} />
        </div>

        <div className="mx-auto mt-16 max-w-[46rem] text-center lg:mt-20">
          <Reveal as="h2" className="t-section">
            {FINALE.title.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </Reveal>
          <Reveal as="p" delay={120} className="t-body mt-8 text-[color:var(--ink-2)]">
            {FINALE.body}
          </Reveal>
        </div>

        <Reveal delay={200} className="mt-20 lg:mt-28">
          <div
            className="relative overflow-hidden rounded-[32px] px-8 py-14 text-center sm:px-16 sm:py-20"
            style={{
              background: "var(--card)",
              border: "1px solid var(--border)",
              boxShadow: "0 50px 90px -60px rgba(36,33,30,.5)",
            }}
          >
            <div
              aria-hidden
              className="glow-blob pointer-events-none absolute left-1/2 top-0 h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2"
              style={{
                background: "radial-gradient(circle, rgba(215,180,138,.34) 0%, rgba(252,247,243,0) 70%)",
              }}
            />
            <p className="t-eyebrow relative">{FINALE.card.eyebrow}</p>
            <h3 className="t-section relative mt-6 !text-[clamp(1.875rem,3.6vw,2.75rem)]">
              {FINALE.card.title}
            </h3>
            <p className="t-body relative mx-auto mt-6 max-w-[34rem] text-[color:var(--ink-2)]">
              {FINALE.card.body}
            </p>
            <div className="relative mt-10 flex flex-wrap justify-center gap-3">
              <button type="button" onClick={openWaitlist} className="btn btn-primary">
                {FINALE.primary}
                <FiArrowRight aria-hidden className="h-[14.4px] w-[14.4px]" />
              </button>
              <Link to="/termin" className="btn btn-ghost">
                {FINALE.secondary}
              </Link>
            </div>
          </div>
        </Reveal>
      </div>

      <footer className="mx-auto mt-28 w-full max-w-[1440px] px-6 pb-14 lg:px-10">
        <div className="hairline" />
        <div className="flex flex-col items-start justify-between gap-8 pt-10 sm:flex-row sm:items-center">
          <div className="flex items-center gap-3">
            <img src="/steffi/logo.png" alt="" aria-hidden className="h-9 w-9" />
            <div>
              <p className="display text-[1rem]">SteffiCare</p>
              <p className="text-[0.9375rem] text-[color:var(--ink-3)]">{FOOTER.tagline}</p>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-7 gap-y-2">
            {FOOTER.legal.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="text-[0.9375rem] text-[color:var(--ink-2)] transition-colors duration-500 hover:text-[color:var(--color-accent)]"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[0.9375rem] text-[color:var(--ink-3)]">{FOOTER.social_label}</p>
          <ul className="flex flex-wrap gap-3">
            {FOOTER.social.map((item) => {
              const Icon = SOCIAL_ICONS[item.icon];
              return (
                <li key={item.label}>
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={item.label}
                    title={item.label}
                    className="flex h-11 w-11 items-center justify-center rounded-full border border-[color:var(--border)] text-[color:var(--ink-2)] transition-colors duration-500 hover:border-[color:var(--color-accent)] hover:text-[color:var(--color-accent)]"
                  >
                    <Icon aria-hidden className="h-[18px] w-[18px]" />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </footer>
    </section>
  );
}
